import { alpha } from '@mui/material/styles'
import { colors } from './colors'
import { IColorOptions } from './types'

export const scaleBorderRadius = (borderRadius: number | string, multiplier: number): string =>
  typeof borderRadius === 'number' ? `${borderRadius * multiplier}px` : `calc(${borderRadius} * ${multiplier})`

export const getColorOptions = (color: string): IColorOptions => ({
  main: color,
  light: alpha(color, 0.25),
  secondary: alpha(color, 0.15),
  soft: alpha(color, 0.1),
  opacity: alpha(color, 0.05),
})

export enum CourseName {
  Biology = 'Biology',
  GeneralChemistry = 'General Chemistry',
  OrganicChemistry = 'Organic Chemistry',
  PerceptualAbility = 'Perceptual Ability',
  QuantitativeReasoning = 'Quantitative Reasoning',
  AnalyticalWriting = 'Analytical Writing',
  VerbalReasoning = 'Verbal Reasoning',
  ReadingComprehension = 'Reading Comprehension',
  Physics = 'Physics',
  Anatomy = 'Anatomy',
  Pharmacology = 'Pharmacology',
  EthicsBehavior = 'Ethics & Behavior',
  FieldsOfDentistry = 'Fields of Dentistry',
  PatientManagement = 'Patient Management',
  DiagnosisDisorders = 'Diagnosis & Disorders',
  Research = 'Research',
  Hidden = 'Hidden',
  Keyholes = 'Keyholes',
  TopFrontEnd = 'Top-Front-End',
  AngleRanking = 'Angle Ranking',
  HolePunching = 'Hole Punching',
  CubeCounting = 'Cube Counting',
  PatternFolding = 'Pattern Folding',
  Periodontics = 'Periodontics',
  PathologyRadiology = 'Pathology & Radiology',
  OralMedicineAndPathology = 'Oral Medicine & Pathology',
  ScientificBasis = 'Scientific Basis',
  Ethics = 'Ethics',
  CommunityHealth = 'Community Health',
  Endodontics = 'Endodontics',
  OralSurgery = 'Oral Surgery',
  Prosthodontics = 'Prosthodontics',
  Orthodontics = 'Orthodontics',
  Operative = 'Operative',
  MedicalEmergencies = 'Medical Emergencies',
  Prescriptions = 'Prescriptions',
  Biochemistry = 'Biochemistry',
  Chemistry = 'Chemistry',
  Psychology = 'Psychology',
  Sociology = 'Sociology',
  Optics = 'Optics',
  OcularPathology = 'Ocular Pathology',
  VisualFunction = 'Visual Function',
  SystemicHealth = 'Systemic Health',
  AnatomyPhysiology = 'Anatomy & Physiology',
  CARS = 'CARS',
}

export const COURSE_COLORS: Record<CourseName, IColorOptions> = {
  [CourseName.Biology]: {
    ...getColorOptions(colors.biology),
  },
  [CourseName.GeneralChemistry]: {
    ...getColorOptions(colors.generalChemistry),
  },
  [CourseName.OrganicChemistry]: {
    ...getColorOptions(colors.organicChemistry),
  },
  [CourseName.PerceptualAbility]: {
    ...getColorOptions(colors.perceptualAbility),
  },
  [CourseName.QuantitativeReasoning]: {
    ...getColorOptions(colors.quantitativeReasoning),
  },
  [CourseName.AnalyticalWriting]: {
    ...getColorOptions(colors.biology),
  },
  [CourseName.VerbalReasoning]: {
    ...getColorOptions(colors.generalChemistry),
  },
  [CourseName.ReadingComprehension]: {
    ...getColorOptions(colors.readingComprehension),
  },
  [CourseName.Physics]: {
    ...getColorOptions(colors.perceptualAbility),
  },
  [CourseName.Anatomy]: {
    ...getColorOptions(colors.anatomy),
  },
  [CourseName.Pharmacology]: {
    ...getColorOptions(colors.pharmacology),
  },
  [CourseName.EthicsBehavior]: {
    ...getColorOptions(colors.ethics),
  },
  [CourseName.Ethics]: {
    ...getColorOptions(colors.ethics),
  },
  [CourseName.FieldsOfDentistry]: {
    ...getColorOptions(colors.fieldsOfDentistry),
  },
  [CourseName.PatientManagement]: {
    ...getColorOptions(colors.patientManagement),
  },
  [CourseName.DiagnosisDisorders]: {
    ...getColorOptions(colors.diagnosisDisorders),
  },
  [CourseName.Research]: {
    ...getColorOptions(colors.research),
  },
  [CourseName.Hidden]: {
    ...getColorOptions(colors.biology),
  },
  [CourseName.Keyholes]: {
    ...getColorOptions(colors.perceptualAbility),
  },
  [CourseName.TopFrontEnd]: {
    ...getColorOptions(colors.perceptualAbility),
  },
  [CourseName.AngleRanking]: {
    ...getColorOptions(colors.perceptualAbility),
  },
  [CourseName.HolePunching]: {
    ...getColorOptions(colors.perceptualAbility),
  },
  [CourseName.CubeCounting]: {
    ...getColorOptions(colors.perceptualAbility),
  },
  [CourseName.PatternFolding]: {
    ...getColorOptions(colors.perceptualAbility),
  },
  [CourseName.Periodontics]: {
    ...getColorOptions(colors.fieldsOfDentistry),
  },
  [CourseName.PathologyRadiology]: {
    ...getColorOptions(colors.diagnosisDisorders),
  },
  [CourseName.OralMedicineAndPathology]: {
    ...getColorOptions(colors.diagnosisDisorders),
  },
  [CourseName.CommunityHealth]: {
    ...getColorOptions(colors.research),
  },
  [CourseName.ScientificBasis]: {
    ...getColorOptions(colors.anatomy),
  },
  [CourseName.Endodontics]: {
    ...getColorOptions(colors.anatomy),
  },
  [CourseName.OralSurgery]: {
    ...getColorOptions(colors.anatomy),
  },
  [CourseName.Prosthodontics]: {
    ...getColorOptions(colors.readingComprehension),
  },
  [CourseName.Orthodontics]: {
    ...getColorOptions(colors.orthodontics),
  },
  [CourseName.Operative]: {
    ...getColorOptions(colors.operative),
  },
  [CourseName.MedicalEmergencies]: {
    ...getColorOptions(colors.patientManagement),
  },
  [CourseName.Prescriptions]: {
    ...getColorOptions(colors.pharmacology),
  },
  [CourseName.Biochemistry]: {
    ...getColorOptions(colors.biology),
  },
  [CourseName.Chemistry]: {
    ...getColorOptions(colors.generalChemistry),
  },
  [CourseName.Psychology]: {
    ...getColorOptions(colors.quantitativeReasoning),
  },
  [CourseName.Sociology]: {
    ...getColorOptions(colors.quantitativeReasoning),
  },
  [CourseName.Optics]: {
    ...getColorOptions(colors.optics),
  },
  [CourseName.OcularPathology]: {
    ...getColorOptions(colors.generalChemistry),
  },
  [CourseName.VisualFunction]: {
    ...getColorOptions(colors.accent),
  },
  [CourseName.SystemicHealth]: {
    ...getColorOptions(colors.quantitativeReasoning),
  },
  [CourseName.AnatomyPhysiology]: {
    ...getColorOptions(colors.biology),
  },
  [CourseName.CARS]: {
    ...getColorOptions(colors.accent),
  },
}

export const SHORT_SUBJECT_NAMES: Record<CourseName, string> = {
  [CourseName.Biology]: 'BIO',
  [CourseName.GeneralChemistry]: 'GC',
  [CourseName.OrganicChemistry]: 'OC',
  [CourseName.PerceptualAbility]: 'PAT',
  [CourseName.Physics]: 'P',
  [CourseName.ReadingComprehension]: 'RC',
  [CourseName.QuantitativeReasoning]: 'QR',
  [CourseName.AnalyticalWriting]: 'AW',
  [CourseName.VerbalReasoning]: 'VR',

  [CourseName.Anatomy]: 'ANTMY',
  [CourseName.Pharmacology]: 'PHARM',
  [CourseName.EthicsBehavior]: 'ETHICS',
  [CourseName.FieldsOfDentistry]: 'FOD',
  [CourseName.PatientManagement]: 'PT. MNGT',
  [CourseName.DiagnosisDisorders]: 'DIAG.',
  [CourseName.Research]: 'RESEARCH',
  [CourseName.Periodontics]: 'PERIO',
  [CourseName.PathologyRadiology]: 'PATH',
  [CourseName.OralMedicineAndPathology]: 'OMP',
  [CourseName.ScientificBasis]: 'SCI. BASIS',
  [CourseName.Ethics]: 'ETHICS',
  [CourseName.CommunityHealth]: 'COM-HLTH',
  [CourseName.Keyholes]: 'KH',
  [CourseName.TopFrontEnd]: 'TFE',
  [CourseName.AngleRanking]: 'AR',
  [CourseName.CubeCounting]: 'CC',
  [CourseName.HolePunching]: 'HP',
  [CourseName.PatternFolding]: 'PF',
  [CourseName.Endodontics]: 'ENDO',
  [CourseName.OralSurgery]: 'OS',
  [CourseName.Prosthodontics]: 'PROSTH',
  [CourseName.Orthodontics]: 'ORTH',
  [CourseName.Operative]: 'OP',
  // new subjects for MCAT, NBEO and DLOSCE - need to confirm short names
  [CourseName.MedicalEmergencies]: 'MED. EMERG',
  [CourseName.Prescriptions]: 'PRESC',
  [CourseName.Biochemistry]: 'BIOCHEM',
  [CourseName.Chemistry]: 'CHEM',
  [CourseName.Psychology]: 'PSY',
  [CourseName.Sociology]: 'SOC',
  [CourseName.Optics]: 'OPT',
  [CourseName.OcularPathology]: 'OP',
  [CourseName.VisualFunction]: 'VF',
  [CourseName.SystemicHealth]: 'SH',
  [CourseName.AnatomyPhysiology]: 'AP',
  [CourseName.Hidden]: '',
  [CourseName.CARS]: 'CARS',
}
